export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAOFps0xQlu70zkEcTEnZ7EodlaIWMmsMU",
  authDomain: "neumomed-prod.firebaseapp.com",
  projectId: "neumomed-prod",
  storageBucket: "neumomed-prod.appspot.com",
  messagingSenderId: "503334291954",
  appId: "1:503334291954:web:9fa492d1d35dfec902836b"
};